/* ============================================
   CAPOEIRA IN MOTION - Theme JavaScript
   Version 2.0.0
   ============================================ */

(function() {
  'use strict';

  // --- Mobile Menu ---
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuClose = document.querySelectorAll('[data-mobile-menu-close]');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    mobileMenuClose.forEach(function(btn) {
      btn.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  // --- Hero Slideshow ---
  function initSlideshow() {
    const slideshows = document.querySelectorAll('.hero-slideshow');
    slideshows.forEach(function(slideshow) {
      const slides = slideshow.querySelectorAll('.hero-slideshow__slide');
      const dots = slideshow.querySelectorAll('.hero-slideshow__dot');
      const speed = parseInt(slideshow.dataset.autoplay) * 1000 || 5000;
      let currentIndex = 0;
      let interval;

      function goToSlide(index) {
        slides.forEach(function(s) { s.classList.remove('active'); });
        dots.forEach(function(d) { d.classList.remove('active'); });
        slides[index].classList.add('active');
        if (dots[index]) dots[index].classList.add('active');
        currentIndex = index;
      }

      function nextSlide() {
        goToSlide((currentIndex + 1) % slides.length);
      }

      function startAutoplay() {
        interval = setInterval(nextSlide, speed);
      }

      function stopAutoplay() {
        clearInterval(interval);
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          stopAutoplay();
          goToSlide(i);
          startAutoplay();
        });
      });

      if (slides.length > 1) {
        startAutoplay();
      }

      // Pause on hover
      slideshow.addEventListener('mouseenter', stopAutoplay);
      slideshow.addEventListener('mouseleave', startAutoplay);
    });
  }

  // --- Product Page: Thumbnail Gallery ---
  function initProductGallery() {
    const thumbs = document.querySelectorAll('.product-page__thumb');
    const mainImage = document.getElementById('product-image-main');

    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const url = this.dataset.imageUrl;
        if (url) {
          mainImage.src = url;
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          this.classList.add('active');
        }
      });
    });
  }

  // --- Product Page: Quantity Buttons ---
  function initQuantityButtons() {
    const minusBtn = document.querySelector('[data-qty-minus]');
    const plusBtn = document.querySelector('[data-qty-plus]');
    const qtyInput = document.getElementById('product-quantity');

    if (!qtyInput) return;

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }
  }

  // --- Product Page: Variant Selection ---
  function initVariantSelector() {
    const sizeButtons = document.querySelectorAll('.product-page__size-btn');
    const variantSelect = document.getElementById('product-select');

    if (!variantSelect || sizeButtons.length === 0) return;

    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optionIndex = parseInt(this.dataset.optionIndex);
        var value = this.dataset.value;

        // Update active state for this option group
        var siblings = this.parentElement.querySelectorAll('.product-page__size-btn');
        siblings.forEach(function(s) { s.classList.remove('active'); });
        this.classList.add('active');

        // Build selected options
        var selectedOptions = [];
        document.querySelectorAll('.product-page__option').forEach(function(optGroup) {
          var activeBtn = optGroup.querySelector('.product-page__size-btn.active');
          if (activeBtn) selectedOptions.push(activeBtn.dataset.value);
        });

        // Find matching variant
        var options = variantSelect.options;
        for (var i = 0; i < options.length; i++) {
          var optionText = options[i].text;
          var match = selectedOptions.every(function(opt) {
            return optionText.indexOf(opt) !== -1;
          });
          if (match) {
            variantSelect.selectedIndex = i;
            break;
          }
        }
      });
    });
  }

  // --- Scroll Animations ---
  function initScrollAnimations() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.featured-collection__header, .image-gallery__header, .image-text__content-col, .newsletter-section__content').forEach(function(el) {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }

  // --- Header Scroll Effect ---
  function initHeaderScroll() {
    var header = document.querySelector('.header__main');
    if (!header) return;

    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.style.boxShadow = '0 4px 30px rgba(0,0,0,0.3)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = currentScroll;
    });
  }

  // --- Smooth Scroll for Anchor Links ---
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // --- Initialize All ---
  document.addEventListener('DOMContentLoaded', function() {
    initSlideshow();
    initProductGallery();
    initQuantityButtons();
    initVariantSelector();
    initScrollAnimations();
    initHeaderScroll();
    initSmoothScroll();
  });

})();
